import React, {Component, PropTypes} from 'react'
import './DebugInfo.scss'

const KEYS_TITLES = {
    price_pred: 'предсказанная цена до коэффициентов',
    address_count: 'число адресов в перевозке (2: по-умолчанию)',
    address_price: 'цена за дополнительный адрес',
    distance: 'расстояние перевозки (км)',
    distance_mkad: 'расстояние перевозки за МКАД (км)',
    in_city: 'перевозка по городу (1) или нет (0)',
    in_region: 'перевозка по региону (1) или нет (0)',
    in_ttk: 'есть ли адреса перевозки внутри ТТК',
    all_volume: 'общий объем грузов, м3',
    all_weight: 'общий вес грузов, т',
    max_hight: 'максимальная высота груза (м)',
    max_length: 'максимальная длинна груза (м)',
    density: 'плотность грузов (кг/м3)',
    split_density: 'граница разделения грузов по плотности (кг)',
    cargo_density_type: 'тип груза по весу, т.е. тяжёлый или нет (зависит от плотности)',
    coef_basic: 'базовый коэффициент',
    coef_flex_price: 'базовый коэффициент на гибкую дату',
    coef_lh: 'коэффициент по максимальной длинне/высоте',
    coef_mkad: 'коэффициент выезда за МКАД',
    coeff_distance: 'коэффициент по расстоянию',
    coeff_mkad_distance: 'коэффициент по расстоюнию за МКАД',
    coeff_weight: 'коэффициент по тяжести груза по грузчикам',
    count_loader: 'число грузчиков',
    floor_load: 'этаж погрузки',
    floor_unload: 'этаж выгрузки',
    lift_pass_load: 'есть или нет пассажирский лифт на погрузке',
    lift_pass_unload: 'есть или нет пассажирский лифт на выгрузке',
    lift_truck_load: 'есть или нет грузовой лифт на погрузке',
    lift_truck_unload: 'есть или нет грузовой лифт на выгрузке',
    ml_version: 'версия движка',
    round_trip: 'кругорейс',
    coef_truck: 'коэффициент по Типу кузова',
    coef_load: 'коэффициент по Типу погрузки',
}

class DebugInfo extends Component {
    static propTypes = {
        data: PropTypes.object,
    }
    
    render() {
        const data = Object.keys(this.props.data).reduce((result, key) => {
            let value = this.props.data[key]
            
            if (value === 'object' || !KEYS_TITLES[key]) {
                return result
            }
            
            if (typeof value === 'boolean') {
                value = value ? 'true' : 'false'
            }
            
            result.push(
                <tr key={key}>
                    <td><span className="DebugInfo-title">{key}</span> ({KEYS_TITLES[key]})</td>
                    <td>{value}</td>
                </tr>,
            )
            
            return result
        }, [])
        
        return (
            <table className="DebugInfo DebugInfo-table container">
                <tbody>
                {data}
                </tbody>
            </table>
        )
    }
}

export default DebugInfo



// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/DebugInfo.js